export default function CustomerAdministrationDirective() {
  return {
    template: require('./customer-administration.directive.html'),
    controller: 'Customer1AdministrationDirectiveController',
    controllerAs: 'customerAdminVM',
    bindToController: true,
    replace: true
  };
}
